import { ResourceType } from '@/contexts/backoffice/library/models/resource'
import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface IresourcetypeSelect {
  value: ResourceType[]
  handleInputChange: (name: string, value: any) => void
  type?: number
}

function ResourceTypeMultiAutocomplete({ value, handleInputChange, type }: IresourcetypeSelect) {
  const { t } = useTranslation(['global'])
  const { resourcetypes } = useSelector((state: IRootState) => state.resourcetype)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleMultiAutoCompleteChange = (resourceTypes: ResourceType[]) => {
    handleInputChange('resourcetypes', resourceTypes)
  }

  return (
    <Autocomplete
      id="multi-autocomplete-resourcetypes"
      value={value || []}
      onChange={(_, value) => {
        handleMultiAutoCompleteChange(value)
      }}
      options={resourcetypes}
      multiple
      limitTags={1}
      sx={type === 1 ? { pt: '3px !important' } : {}}
      getOptionLabel={(option: any) => option?.name || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => (
        <TextField
          {...params}
          label={type === 1 ? '' : `${t('type')}*`}
          variant="filled"
          placeholder={type === 1 ? t('type') : ''}
          InputLabelProps={{ shrink: type !== 1 }}
          error={errorForm.resourcetypeId}
          helperText={msgForm.resourcetypeId}
        />
      )}
    />
  )
}

export default ResourceTypeMultiAutocomplete
